// removed by extract-text-webpack-plugin
module.exports = {"Scalar":"hhEHI","Value":"_2E6wc","Title":"_2AmGX","small":"VLiPj","large":"xwOzD"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/visualizations/Scalar.css
// module id = 460
// module chunks = 3 4 5